import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { Suspense } from 'react';
import NotFound from '../pages/NotFound';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const Home = lazy(() => import('../pages/home/page'));
const Salas = lazy(() => import('../pages/salas/page'));
const SalaDetalhes = lazy(() => import('../pages/sala-detalhes/page'));
const Coworking = lazy(() => import('../pages/coworking/page'));
const QuemSomos = lazy(() => import('../pages/quem-somos/page'));
const Parceiros = lazy(() => import('../pages/parceiros/page'));
const Noticias = lazy(() => import('../pages/noticias/page'));
const NoticiaDetalhes = lazy(() => import('../pages/noticia-detalhes/page'));
const Contato = lazy(() => import('../pages/contato/page'));
const FAQ = lazy(() => import('../pages/faq/page'));
const AgendaCoworking = lazy(() => import('../pages/agenda-coworking/page'));
const Login = lazy(() => import('../pages/login/page'));
const RedefinirSenha = lazy(() => import('../pages/redefinir-senha/page'));

function AdminPage() {
  const Component = lazy(() => import('../pages/admin/page'));
  return (
    <ProtectedRoute>
      <Suspense fallback={<div>Carregando...</div>}>
        <Component />
      </Suspense>
    </ProtectedRoute>
  );
}

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/salas',
    element: <Salas />,
  },
  {
    path: '/sala/:id',
    element: <SalaDetalhes />,
  },
  {
    path: '/coworking',
    element: <Coworking />,
  },
  {
    path: '/quem-somos',
    element: <QuemSomos />,
  },
  {
    path: '/parceiros',
    element: <Parceiros />,
  },
  {
    path: '/noticias',
    element: <Noticias />,
  },
  {
    path: '/noticia-detalhes/:id',
    element: <NoticiaDetalhes />,
  },
  {
    path: '/contato',
    element: <Contato />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
  {
    path: '/agenda-coworking',
    element: <AgendaCoworking />,
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/redefinir-senha',
    element: <RedefinirSenha />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
